import React from 'react';
import { Box } from 'bloomer';
import { Subtitle } from 'bloomer/lib/elements/Subtitle';
import styled from 'styled-components';
import { Link } from '@reach/router';
import CreateAccount from '../components/CreateAccount';
import { Container } from 'bloomer/lib/layout/Container';

const CenteredSubtitle = styled(Subtitle)`
  text-align: center;
  margin-top: 8px;
`;

interface StateTypes {}

interface PropTypes {
  path: string;
}

const SignUp = (props: PropTypes) => (
  <Container>
    <Box>
      <CreateAccount />
      <CenteredSubtitle>
        Already have an account? Click <Link to="/login">here</Link>
      </CenteredSubtitle>
    </Box>
  </Container>
);

export default SignUp;
